import { css } from 'linaria';

const DESKTOP_WIDTH = 574;
const DESKTOP_HEIGHT = 468;

const preview = css`
  width: 100%;
  opacity: 0.8;
  transition:
    opacity 0.2s ease,
    transform 0.1s;

  @media (min-width: 1366px) {
    min-height: ${DESKTOP_HEIGHT}px;
  }
`;

const pictureContainer = css`
  width: 100%;
  overflow: hidden;
`;

const picture = css`
  display: block;

  @media (min-width: 768px) {
    max-width: ${DESKTOP_WIDTH}px;
  }

  @media (max-width: 1023px) {
    margin: 0 auto;
  }
`;

const img = css`
  display: block;
  width: 100%;
  height: 100%;
  margin: 0 auto;
`;

const zoomCursor = css`
  cursor: crosshair;
`;

const videoContainer = css`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-width: 100%;
  min-height: 100%;
  background-color: var(--brand-minor);
`;

const sliderContainer = css`
  overflow: hidden;
`;

const slider = css`
  display: flex;
  transition: transform 0.2s ease-out;
`;

const videoWrapper = css`
  position: relative;
  min-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const video = css`
  display: block;
  width: 100%;
  margin: 0 auto;
  pointer-events: auto;
  cursor: pointer;
  &::-webkit-media-controls-overlay-play-button {
    display: none;
  }
`;

const playIconWrapper = css`
  position: absolute;
  display: block;
  margin: auto;
  width: 100%;
  height: 100%;
  z-index: 9;
  cursor: pointer;
`;

const playIcon = css`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50px;
  height: 50px;
  display: block;
  transform: translate(-50%, -50%);
  z-index: 10;
  svg {
    &[data-is-playing='true'] {
      display: none;
    }
  }
`;

const arrow = css`
  position: absolute;
  top: 50%;
  display: flex;
  justify-content: center;
  z-index: 10;
  width: 40px;
  height: 40px;
  transform: translateY(-50%);
  background-color: var(--control-invert);
  box-shadow: var(--box-shadow-m);

  transition: opacity 0.2s ease 0s;
  cursor: pointer;
  border-radius: 50%;

  &:hover {
    background-color: var(--control-invert);
  }
`;

const arrowLeft = css`
  left: -20px;
`;

const arrowRight = css`
  right: -20px;
`;

const arrowAnimation = css`
  animation: backgroundChange 1s ease-out;
  svg {
    path {
      animation: fillChange 1s ease-out;
    }
  }

  @keyframes backgroundChange {
    50% {
      background: var(--control-primary);
    }
    100% {
      background: var(--control-invert);
    }
  }

  @keyframes fillChange {
    50% {
      fill: var(--control-invert);
    }
    100% {
      fill: var(--text-primary);
    }
  }
`;

export {
  arrow,
  arrowLeft,
  arrowRight,
  arrowAnimation,
  img,
  picture,
  pictureContainer,
  playIcon,
  playIconWrapper,
  preview,
  slider,
  sliderContainer,
  video,
  videoContainer,
  videoWrapper,
  zoomCursor,
};
